var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ql-editor"},[_c('div',_vm._b({domProps:{"innerHTML":_vm._s(_vm.$lt(_vm.innerValue.text))}},'div',_vm.innerValue.attr,false))])
}
var staticRenderFns = []

export { render, staticRenderFns }